import {setStore} from '../../../../src/utility/setStore'
export default {
    SET_CAREERS_ARTS(state,data) {
        state.careersArts = data;
        //setStore('moduleName','Key',value)
        setStore('website','careers,careersArts,list',data)
    },
    SET_CURRENT_CAREERS_ART(state,data) {
        state.currentCareersArt = data;
        //setStore('moduleName','Key',value)
        setStore('website','careers,careersArts,currentCareersArt',data)
    },
    SET_CAREERS_FIELDS(state,data) {
        state.careersFields = data;
        //setStore('moduleName','Key',value)
        setStore('website','careers,careersFields,list',data)
    },
    SET_CURRENT_CAREERS_FIELD(state,data) {
        state.currentCareersField = data;
        //setStore('moduleName','Key',value)
        setStore('website','careers,careersFields,currentCareersField',data)
    },
    SET_DEPARTMENTS(state,data) {
        state.list = data;
        //setStore('moduleName','Key',value)
        setStore('website','careers,departments,list',data)
    },
    SET_CURRENT_SET_DEPARTMENT(state,data) {
        state.currentDepartment = data;
        //setStore('moduleName','Key',value)
        setStore('website','careers,departments,currentDepartment',data)
    },
};
